<template>
  <span class="text-lg font-bold ml-2 mt-2">{{ preset.name }} bewerken</span>
  <div class="m-2">
    <FormKit
      type="form"
      :actions="false"
      @submit="onSave"
    >
      <AppInput
        type="text"
        id="name"
        name="name"
        label="Naam"
        :value="data.name"
        v-model="data.name"
      >
      </AppInput>
      <AppInput type="toggle" name="isShared" label="Profiel delen" alt-label-position :value="data.isShared"
                v-model="data.isShared"/>
      <AppInput
        type="autocomplete"
        id="allowedRoleIds"
        v-model="data.allowedRoleIds"
        name="allowedRoleIds"
        label="Toegestane rollen"
        :optionSource="$isAllowed('read role') ? '/api/roles' : null"
        :optionsSource="$isAllowed('read role') ? '/api/roles' : null"
        :options="!$isAllowed('read role') ? mapRoles() : {}"
        :disabled="!data.isShared"
        help="Indien dit veld leeg blijft, wordt dit profiel met iedereen gedeeld"
        multiple
      />
      <AppButton @click="onCancel">
        Annuleren
      </AppButton>
      <AppButton icon="fa-save" type="submit" class="float-end mb-2">
        Opslaan
      </AppButton>
    </FormKit>
  </div>
</template>

<script setup lang="ts">
import { updateGridPreset, UserGridPreset } from "@q-food/q-food";
import { useUserStore } from "~stores/User.ts";
import { ref } from "vue";

const props = defineProps({
	preset: {} as UserGridPreset,
});

const { activeUser } = storeToRefs(useUserStore());

const emit = defineEmits<{
	(e: "cancel"): void;
	(e: "onSave"): void;
}>();

const { error, success } = useToast();

const data = ref({
	name: props.preset?.name,
	isShared: props.preset?.isShared,
	allowedRoleIds: props.preset?.allowedRoles?.map((role) => role.id),
});

async function onSave() {
	await updateGridPreset(props?.preset?.id, {
		gridKey: props.preset?.gridKey,
		name: data.value.name,
		columnState: props.preset?.columnState,
		filterState: props.preset?.filterState,
		allowedRoleIds: data.value?.allowedRoleIds,
		isShared: data.value.isShared,
	})
		.then(() => {
			success("Profiel succesvol opgeslagen");
			emit("onSave");
		})
		.catch((e) => {
			console.log(e);
			const errorMessage = e.message ?? "Er is iets misgegaan";
			error(errorMessage);
		});
}

function onCancel() {
	emit("cancel");
}

function mapRoles() {
	return activeUser.value.roles.map((role) => ({ label: role.name, value: role.id }));
}
</script>

<style scoped>

</style>
